import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

/** Compact collapsible section. Empty sections render as a single muted line. */
export function Collapsible({ title, icon: Icon, children, empty = false, emptyText = "Nothing on file", defaultOpen = false, testId, action }) {
  const [open, setOpen] = useState(defaultOpen);
  if (empty) {
    return (
      <div className="flex items-center justify-between rounded-lg border border-slate-200 bg-white px-4 py-2.5" data-testid={testId}>
        <span className="text-sm font-medium text-slate-700 flex items-center gap-2">{Icon && <Icon className="w-4 h-4 text-slate-400" />}{title}</span>
        <span className="flex items-center gap-3 text-xs text-slate-400">{emptyText}{action}</span>
      </div>
    );
  }
  return (
    <div className="rounded-lg border border-slate-200 bg-white" data-testid={testId}>
      <div className="flex items-center justify-between px-4 py-2.5">
        <button type="button" onClick={() => setOpen((o) => !o)} aria-expanded={open} className="flex-1 flex items-center gap-2 text-left text-sm font-medium text-slate-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand/40 rounded" data-testid={testId && `${testId}-toggle`}>
          {Icon && <Icon className="w-4 h-4 text-brand" />}{title}
          <ChevronDown className={`w-4 h-4 text-slate-400 ml-auto transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
        </button>
        {action && <span className="ml-3">{action}</span>}
      </div>
      {open && <div className="border-t border-slate-100 px-4 py-3">{children}</div>}
    </div>
  );
}
